import { useMutation, type useQueryClient } from '@tanstack/react-query'
import { patchJSON, postFormData } from '@/lib/api'
import { type EventDetails } from '@/components/events/event-details-form'

export function useEventHeroImageUpdate(
  event: EventDetails,
  queryClient: ReturnType<typeof useQueryClient>,
  setHeroImage: (image: EventDetails['hero_image']) => void,
) {
  return useMutation({
    mutationFn: async (file: File | null) => {
      let heroImageId: number | null = null
      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        const uploaded = await postFormData<{ upload: { id: number } }>('/api/v1/uploads', formData)
        heroImageId = uploaded.upload.id
      }
      return patchJSON<{ event: EventDetails }>(`/api/v1/events/${event.id}`, {
        event: { hero_image_id: heroImageId },
      })
    },
    onSuccess: ({ event: updated }) => {
      setHeroImage(updated.hero_image)
      queryClient.setQueryData(['event', event.id], { event: updated })
      queryClient.invalidateQueries({ queryKey: ['events'] })
    },
  })
}
